{
  "form": {
    "input_placeholder": "Bir görev ekle…",
    "parseWithAi_aria": "Görevi AI ile ayrıştır",
    "parseWithAi_title": "AI ile düzenle ve öncelik belirle",
    "priorityLabel_aria": "Görev önceliği",
    "add": "Ekle",
    "signInForAi": "AI özelliklerini kullanmak için giriş yapın.",
    "aiUnavailable": "AI kullanılamıyor. Tekrar deneyin.",
    "saveTo": "Kaydet",
    "saveTo_aria": "{{list}} listesine kaydet",
    "saveToSynced_aria": "{{list}} listesine kaydet, {{provider}}",
    "addedTo": "{{list}} listesine eklendi",
    "addedToSynced": "{{list}} listesine eklendi · {{provider}}",
    "show": "Göster"
  },
  "priority": {
    "Critical": "Kritik",
    "High": "Yüksek",
    "Medium": "Orta",
    "Low": "Düşük"
  },
  "item": {
    "edit_aria": "Görevi düzenle",
    "delete_aria": "Görevi sil",
    "addStep": "Adım ekle",
    "addStep_placeholder": "Adım ekle…",
    "addStep_aria": "{{task}} görevine adım ekle",
    "steps_group_aria": "{{task}} adımları",
    "steps_progress_aria": "{{count}} adımdan {{done}} tanesi tamamlandı",
    "completeSteps_aria": "{{task}}. Açık {{count}} adımı da tamamlar"
  },
  "list": {
    "title": "Görevler",
    "newListFallback": "Yeni Liste",
    "completedMeta": "{{total}} görevden {{completed}} tamamlandı",
    "deleteConfirm": "\"{{name}}\" silinsin mi?",
    "rename_title": "Yeniden adlandır",
    "deleteList_title": "Listeyi sil",
    "newListName_placeholder": "Liste adı…",
    "newList": "Yeni liste",
    "done": "Tamam",
    "emptyTitle": "Henüz görev yok",
    "emptySubtitle": "Başlamak için aşağıdan bir tane ekleyin.",
    "noFilterMatch": "Bu filtreye uyan görev yok.",
    "createIn": "Oluşturulacak yer",
    "inDestination": "{{destination}} içinde",
    "createIn_aria": "{{destination}} içinde oluştur",
    "createInAccount_aria": "{{destination}} içinde oluştur, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "{{destination}} içinde oluşturuluyor…",
    "createFailed": "“{{name}}”, {{destination}} içinde oluşturulamadı.",
    "createLimit": "{{destination}} liste sınırına ulaştı.",
    "keepInRhemn": "Rhemn'de tut"
  },
  "filter": {
    "label": "Filtre",
    "all": "Tümü"
  },
  "voice": {
    "mic_aria": "Sesle görev ekle",
    "mic_title": "Görevlerini söyle — öncelik ve zamana göre sıralanır",
    "stop_aria": "Durdur ve görevleri sırala",
    "recording": "Kaydediliyor",
    "sorting": "Görevlerin sıralanıyor…",
    "stripTitle": "Duyulan görevler",
    "stripCount": "{{checked}} / {{total}}",
    "discard": "Vazgeç",
    "addN": "{{count}} ekle",
    "addZero": "Ekle",
    "adding": "Ekleniyor…",
    "parseFallback": "Sıralanamadı — sözlerin kutuda.",
    "nothingHeard": "Anlaşılmadı — tekrar dene.",
    "micDenied": "Mikrofon engelli — ayarlardan izin ver.",
    "gateBody": "Görevlerini söyle — öncelik ve namaz vaktine göre sıralanır. Pro ile birlikte.",
    "listen_aria": "Dinleniyor — görevlerini söyle"
  }
}
